<div class="library-card" *ngIf="library">
    <div class="card-image-wrapper">
        <img loading="lazy" 
             [src]="library.image || fallbackImage" 
             [alt]="library.name || ''">
    </div>
    
    <div class="card-content">
        <div class="card-header-row">
            <h5 class="library-title" [title]="library.name">{{ library.name }}</h5>
            <!-- <span class="titles-badge">
                {{ library.titles_count || library.count || library.holdings_count || 1550 }} {{ 'TITLES' | translate }}
            </span> -->
        </div>

        <div class="card-info">
            <!-- <svg class="location-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                <circle cx="12" cy="10" r="3"/>
            </svg> -->
            <p>{{ library.notes }}</p>
        </div>


        <div class="card-action">
            <a routerLink="/browse-index" [queryParams]="{ library: library.library_id }" class="btn-read-more" translate="READ_MORE"></a>
        </div>
    </div>
</div>